<div class="landing-background">
  <div class="background-gradient" [class.background-gradient--login]="isLoginPage()"></div>
  <div class="buildings-overlay" [class.buildings-overlay--login]="isLoginPage()"></div>
  <div class="content-overlay">
    <ng-content></ng-content>
  </div>
</div>